var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0781 2.49219C10.0391 2.45312 9.96094 2.45312 9.88281 2.49219L2.46094 5.30469L10 8.27344L17.5 5.30469L10.0781 2.49219ZM1.875 15.2656C1.875 15.4219 1.95312 15.5391 2.07031 15.5781L9.0625 18.2344V9.91406L1.875 7.10156V15.2656ZM10.9375 18.2344L17.8906 15.5781C18.0078 15.5391 18.125 15.4219 18.125 15.2656V7.10156L10.9375 9.91406V18.2344ZM9.21875 0.734375C9.6875 0.539062 10.2734 0.539062 10.7422 0.734375L18.5547 3.70312C19.4141 4.01562 20 4.83594 20 5.77344V15.2656C20 16.2031 19.4141 16.9844 18.5547 17.3359L10.7422 20.3047C10.2734 20.5 9.72656 20.5 9.21875 20.3047L1.40625 17.3359C0.546875 16.9844 0 16.2031 0 15.2656V5.77344C0 4.83594 0.546875 4.01562 1.40625 3.70312L9.21875 0.734375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCube);
export default __webpack_public_path__ + "static/media/cube.88dfe38c6a33c8e004cf1ba0c98e1f9a.svg";
export { ForwardRef as ReactComponent };